import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import SimulationMonitorLogTableService from '../service/SimulationMonitorLogTableService';

const config = {
	key: 'simulationMonitorLogTable',
	topic: 'simulationMonitorLog',
	service: SimulationMonitorLogTableService,
	editFormState: item => `/simulation-monitor-log/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}simulationMonitorLogTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		}
	]
};

function SimulationMonitorLogTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('simulationMonitorLogTable', reducer('simulationMonitorLogTable'))(SimulationMonitorLogTable);
